<template>
    <treeselect v-bind="$attrs" v-on="inputListeners" :disableFuzzyMatching="true">
        <label slot="option-label" slot-scope="{ node, labelClassName }" :class="labelClassName" v-html="vueSelectHighlightTerm(searchTerm, node)" />
    </treeselect>
</template>

<script>
    import { Treeselect } from '@riophae/vue-treeselect'
    export default {
        name: 'custom-treeselect',
        data() {
            return {
                searchTerm: null
            }
        },
        created() { },
        methods: {
            treeSearchChange(term, id) {
                this.searchTerm = term;
            },
            vueSelectHighlightTerm(term, node) {
                if (term && term.length) {
                    let regex = new RegExp(term, 'gi')
                    return node.label.replace(regex, '<span class="select-highlight">$&</span>')
                } else {
                    return node.label
                }
            }
        },
        components: {
            Treeselect
        },
        computed: {
            inputListeners: function () {
                var vm = this
                // `Object.assign` merges objects together to form a new object
                return Object.assign({},
                    // We add all the listeners from the parent
                    this.$listeners,
                    // Then we can add custom listeners or override the
                    // behavior of some listeners.
                    {
                        'search-change': this.treeSearchChange
                    }
                )
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/CustomControl/CustomTreeSelect.vue